<template>
  <canvas ref="chart"></canvas>
</template>

<script>
import { Chart } from "chart.js";

export default {
  name: "PieChart",
  props: {
    chartData: {
      type: Object,
      default: () => ({ labels: [], values: [] }),
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    renderChart() {
      if (!this.chartData || !this.chartData.labels) return;

      if (this.chart) {
        this.chart.destroy();
      }

      const ctx = this.$refs.chart.getContext("2d");

      const datalabelsPlugin = {
        id: 'pieDatalabels',
        afterDatasetsDraw(chart) {
          const { ctx } = chart;
          chart.data.datasets.forEach((dataset, datasetIndex) => {
            const meta = chart.getDatasetMeta(datasetIndex);
            meta.data.forEach((arc, index) => {
              const value = dataset.data[index];
              if (value === 0) return;

              const { x, y } = arc.tooltipPosition();
              ctx.save();
              ctx.fillStyle = '#ffffff';
              ctx.font = 'bold 14px sans-serif';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.fillText(value, x, y);
              ctx.restore();
            });
          });
        },
      };

      const defaultColors = [
        "#2e4664",
        "#4a7c59",
        "#f4a261",
        "#e76f51",
        "#264653",
        "#9ca3af",
        "#f59e0b",
        "#f97316",
        "#06b6d4",
        "#8b5cf6",
        "#ec4899",
        "#84cc16",
        "#14b8a6",
        "#6366f1",
        "#a855f7",
        "#eab308",
      ];
      const colors = this.chartData.colors || defaultColors;

      this.chart = new Chart(ctx, {
        type: "pie",
        data: {
          labels: this.chartData.labels,
          datasets: [
            {
              data: this.chartData.values,
              backgroundColor: colors,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: "right",
            },
          },
        },
        plugins: [datalabelsPlugin],
      });
    },
  },
};
</script>
